class Categoria {
  constructor(dados) {
    this.id = dados.id;
    this.nome = dados.nome;
    this.cor = dados.cor;
  }
}
export default Categoria;
